"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PapermillView = undefined;

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var PapermillView = exports.PapermillView = function PapermillView(props) {
  if (!props.status) {
    return null;
  }

  if (props.status === "running") {
    return React.createElement(
      React.Fragment,
      null,
      React.createElement(
        "div",
        {
          className: "jsx-2667973196" + " " + "papermill"
        },
        "Executing with Papermill..."
      ),
      React.createElement(_style2.default, {
        styleId: "2667973196",
        css: ".papermill.jsx-2667973196{width:100%;background-color:#e8f2ff;padding-left:10px;padding-top:1em;padding-bottom:1em;padding-right:0;margin-right:0;box-sizing:border-box;}"
      })
    );
  }
  return null;
};
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PapermillView, "PapermillView", "src/papermill.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/notebook-preview/lib/papermill.js
// module id = 205
// module chunks = 186292428941015